import { delayAction } from "#root/lib/delay_action";
export function showPopup() {
  let popup = document.querySelector(".bottom-popup");
  let popupBlock = document.createElement("div");

  if (!popup) {
    popup = document.createElement("div");
    popup.classList.add("bottom-popup");
    popupBlock = document.createElement("div");
    popupBlock.classList.add("bottom-popup-block");
    popup.appendChild(popupBlock);
    document.body.appendChild(popup);
  } else {
    popupBlock = popup.querySelector(".bottom-popup-block");
  }

  delayAction(() => {
    popup.classList.add("active");
  });
  return popupBlock;
}
export function hidePopup() {
  const popup = document.querySelector(".bottom-popup");

  if (popup) {
    delayAction(() => {
      popup.classList.remove("active");
    });
  }
}